import React, {useEffect, useState} from 'react';
import { withStyles } from "@mui/styles";
import {Paper} from "@mui/material";
import HelpSection from "./HelpSection";
import HelpDialog from "./HelpDialog";
import {connect} from "react-redux";
import {addHelpEdit, loadHelpEdits, loadHelpFile} from "../../../state/actions/helpActions";

const styles = {
  root: {
    maxWidth: "1200px",
    margin: "10px auto",
    padding: 0
  },
  bottomSpacer:{
    height:"90dvh"
  }
};

// const dumpMerged = (field, data) => console.log(field, Object.fromEntries(Object.entries(data[field]).map(([k, item]) => [k, data.edits[k]?.[field] || item])));

function HelpPage(props) {
  const { variant="page", isOpen, setOpen, helpData, loadHelpFile, loadHelpEdits, addHelpEdit, isAdmin, classes } = props;
  const [needsReload, setNeedsReload] = useState(0);

  const dump = null;
    // <Button onClick={() => {
    //   console.log(helpData)
    //   dumpMerged("text", helpData)
    //   dumpMerged("titles", helpData)
    //   dumpMerged("opts", helpData)
    // }} variant="contained" color="secondary">
    //   Dump
    // </Button>;

  useEffect(() =>{
    loadHelpEdits();
    loadHelpFile("titles");
    loadHelpFile("text");
    loadHelpFile("opts");
    loadHelpFile("structure");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [needsReload]);

  return !helpData?.sections || Object.entries(helpData.sections).length === 0 ? null :
    variant === "dialog" ?
    <HelpDialog
      helpSections={helpData.sections}
      pathMap={helpData.pathMap}
      orderMap={helpData.orderMap}
      isOpen={isOpen}
      setOpen={setOpen}
      reloadHelp={() => setNeedsReload(needsReload+1)}
      addHelpEdit={addHelpEdit}
      isAdmin={isAdmin}
    >{dump}</HelpDialog>
    : (
    <div>
      <Paper className={classes.root}>
        {dump}
        {Object.entries(helpData.sections).map(([sectionId,section]) => {
            return <HelpSection
              key={sectionId}
              sectionId={sectionId}
              section={section}
              addHelpEdit={addHelpEdit}
              isAdmin={isAdmin}
            />;
          }
        )}
      </Paper>
      <div className={classes.bottomSpacer}/>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    user: state.auth,
    helpData: state.helpData,
    isAdmin: state.mindfileUserLevel.admin,
  };
}
const mapDispatchToProps = {
  addHelpEdit,
  loadHelpEdits,
  loadHelpFile
};
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(HelpPage));